var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('AppEchartBar',{staticClass:"mt-1",staticStyle:{"width":"850px","height":"320px"},attrs:{"option-data":_vm.option}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }